const emailToName = (email: string) => {
  const [name] = email.split("@");
  return name.split(".").join(" ");
};

export default emailToName;
